import Vue from 'vue'
import Router from 'vue-router'
import getToken from '@/pages/getToken/getToken'
import index from '@/pages/index/index'
import certificateApproval from '@/pages/COC/certificateApproval'
import analysis from '@/pages/COA/analysis'
import barCode from '@/pages/COA/barCode'
import certificateResult from '@/pages/COC/certificateResult'
import analyzeResult from '@/pages/COA/analyzeResult'
import personalAnalysis from '@/pages/COA/personalAnalysis'
import personalBarCode from '@/pages/COA/personalBarCode'
import personalAnalyzeResult from '@/pages/COA/personalAnalyzeResult'
import certificateDetail from '@/pages/COC/certificateDetail'
import analysisDetail from '@/pages/COA/analysisDetail'
import personalAnalysisDetail from '@/pages/COA/personalAnalysisDetail'
import selectEmail from '@/pages/email/selectEmail'
import addEmail from '@/pages/email/addEmail'
import certificateFind from '@/pages/find/certificateFind'
import certificateResult1 from '@/pages/find/certificateResult1'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: 'getToken'
        },
        {
            path: '/getToken',
            component: getToken,
            meta: {
                title: '授权'
            }
        },
        {
            path: '/index',
            component: index,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/certificateApproval',
            component: certificateApproval,
            meta: {
                title: '产品合格证书（COC）查询'
            }
        },
        {
            path: '/certificateResult',
            component: certificateResult,
            meta: {
                title: '产品合格证（COC）查询结果'
            }
        },
        {
            path: '/certificateDetail',
            component: certificateDetail,
            meta: {
                title: '产品合格证书（COC）'
            }
        },
        {
            path: '/analysis',
            component: analysis,
            meta: {
                title: '标准产品分析报告（标准COA）查询'
            }
        },
        {
            path: '/barCode',
            component: barCode,
            meta: {
                title: '标准产品分析报告（标准COA）查询'
            }
        },
        {
            path: '/analyzeResult',
            component: analyzeResult,
            meta: {
                title: '标准产品分析报告（标准COA）查询结果'
            }
        },
        {
            path: '/analysisDetail',
            component: analysisDetail,
            meta: {
                title: '标准产品分析报告（标准COA）'
            }
        },
        {
            path: '/personalAnalysis',
            component: personalAnalysis,
            meta: {
                title: '定制产品分析报告（定制COA）查询'
            }
        },
        {
            path: '/personalBarCode',
            component: personalBarCode,
            meta: {
                title: '定制产品分析报告（定制COA）查询'
            }
        },
        {
            path: '/personalAnalyzeResult',
            component: personalAnalyzeResult,
            meta: {
                title: '定制产品分析报告（定制COA）查询结果'
            }
        },
        {
            path: '/personalAnalysisDetail',
            component: personalAnalysisDetail,
            meta: {
                title: '定制产品分析报告（定制COA）'
            }
        },
        {
            path: '/selectEmail',
            component: selectEmail,
            meta: {
                title: '选择邮箱'
            }
        },
        {
            path: '/addEmail',
            component: addEmail,
            meta: {
                title: '新增/编辑邮箱'
            }
        },
        {
            path: '/certificateFind',
            component: certificateFind,
            meta: {
                title: '钢瓶追溯查询'
            }
        },
        {
            path: '/certificateResult1',
            component: certificateResult1,
            meta: {
                title: '气瓶追溯查询'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '未定义标题'
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js